import React from "react";

import NavList from "./NavList";
import NavListItem from "./NavListItem";

// Transforms the nav object into an array, which is more useful for recursion. Then we no longer
// have to worry about mapping on the keys if depth < 1.
const makeArray = obj => {
  const keys = Object.getOwnPropertyNames(obj);
  return keys.reduce((p, c) => {
    p.push(obj[c]);
    return p;
  }, []);
};

const mapChildren = function mapChildren(children, depth, path) {
  // Map the children and return them.
  return children.sort((a, b) => a.order - b.order).map((c, i) => {
    return (
      // Set useful classes for NavListItem based on depth, index and name for styling.
      <NavListItem
        className={`nav-list-item-depth-${depth} nav-list-item-index-${i} nav-list-item-name-${
          c.name
        } ${c.children ? "has-children" : ""}`}
        item={c}
        key={`nav-list-item-${c.name}`}
        current={path.path == c.slug}
        path={path}
      >
        {/*
          If c has children recursively execute this function with children and depth + 1.
          Otherwise, return nothing
        */}
        {c.children.length > 0 ? (
          <NavList className={`nav-list-depth-${depth}`}>
            {mapChildren(c.children, depth + 1, path)}
          </NavList>
        ) : null}
      </NavListItem>
    );
  });
};

export default function createNav(obj, depth = 0, path) {
  return (
    // Create the top level list and recursively map the navigation array.
    <NavList className={`nav-list-depth-${depth}`}>
      {mapChildren(makeArray(obj), depth, path)}
    </NavList>
  );
}



// WEBPACK FOOTER //
// ./src/components/Navigation/createNavTree.js